import React from 'react';
import { withTranslation } from 'react-i18next';
import GoalServices from '../../services/goal.services';
import IntegrationServices from '../../services/integration.services';
import { buildGoalAlignPrintQueryString, pickGoalAlignPrintParams } from '../../utils/goalAlignPrintParams';

class PublisherComp extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            showEmailPopup: false,
            errors: '',
            showSlackPopup: false,
            slackData: {},
            disableClick: false
        };
        this.clickPrintView = this.clickPrintView.bind(this);
        this.clickEmailView = this.clickEmailView.bind(this);
        this.clickSlackView = this.clickSlackView.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.publishSlack = this.publishSlack.bind(this);
        this.changeSlackCheckBox = this.changeSlackCheckBox.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.clearCheckBoxes = this.clearCheckBoxes.bind(this);

        this.GoalServices = new GoalServices();
        this.IntegrationServices = new IntegrationServices();
    }

    componentDidMount(){
        window.addEventListener('mousedown', this.hidePopup);
    }

    componentWillUnmount(){
        window.removeEventListener('mousedown', this.hidePopup);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    hidePopup(event){
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({showEmailPopup: false, showSlackPopup: false, errors: ''}, () => {
                this.refs.emails.value = '';
                this.refs.subject.value = '';
            });
        }
    }

    clickPrintView(e){
        e.preventDefault();
        this.setState({showEmailPopup: false, showSlackPopup: false});
        let url = `${wbConfig.baseUrl}/${this.props.printUrl}`;
        if (typeof this.props.getPrintQueryParams === 'function') {
            const q = buildGoalAlignPrintQueryString(this.props.getPrintQueryParams());
            if (q) {
                url += `?${q}`;
            }
        }
        return window.open(url, '_blank');
    }

    clickEmailView(e){
        e.preventDefault();
        this.setState({showEmailPopup: true, showSlackPopup: false}, () => {
            /*this.refs.emails.value = '';
            this.refs.subject.value = '';*/
        });
    }

    async clickSlackView(e){
        if(this.state.disableClick == true) {
            return;
        }
        showLoader($(".contentTd2 #content"));
        this.setState({disableClick: true});
        await publishingReportsInExternalSystem('integration/goalAlighnPublish');
        this.setState({disableClick: false});
    }

    changeSlackCheckBox(e, slack){
        console.log('changeSlackCheckBox', e.target.checked);
    }

    sendEmail(e){
        e.preventDefault();
        let _this = this;
        let emails = this.refs.emails.value.trim();
        let subject = this.refs.subject.value.trim();
        let errors = '';
        if (emails == '' || emails == null) {
            errors = 'please enter the email address';
        }
        if(errors){
            this.setState({errors: errors});
        }
        else{
            var emailsArray = emails.split(/[,]+/); // split element by ,
            let userEmails = [];
            if(Array.isArray(emailsArray)){
                for(let v of emailsArray){
                    var value = v.trim();
                    if (!/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-+]+)*@[A-Za-z0-9-]+(\.[a-z0-9-]+)*(\.[A-Za-z]{2,20})$/.test(value)) {
                        errors = 'please enter the valid email address';
                        break;
                    }
                    userEmails.push(value);
                }
            }
            if(!userEmails.length){
                errors = 'please enter the email address';
            }
            if(errors){
                this.setState({errors: errors});
            }
            else{
                showLoaderWidget($("#content"));
                const alignParams = typeof this.props.getPrintQueryParams === 'function'
                    ? pickGoalAlignPrintParams(this.props.getPrintQueryParams())
                    : {};
                this.GoalServices.sendPublishEmail(this.props.emailSendUrl, {
                    ...alignParams,
                    users: userEmails,
                    subject: subject,
                })
                    .then(function(response){
                        removeLoaderWidget();
                        if (response.data.error) {
                            _this.setState({errors: response.data.error});
                        } else {
                            var text = '';
                            if(response.data.notSendMail =='') {
                                text = ' &nbsp;&nbsp;&nbsp;Email successfully sent.';
                            } else {
                                text = ' &nbsp;&nbsp;&nbsp;Not allowed to email goals outside the organization.('+response.data.notSendMail+')';
                            }
                            infoPopup.call(text, 5000);
                            _this.setState({errors:'', showEmailPopup: false, showSlackPopup: false}, () => {
                                _this.refs.emails.value = '';
                                _this.refs.subject.value = '';
                            });
                        }
                    });
            }
        }
       
    }

    renderEmailPopup(){
        const { t } = this.props;
        let _style = {display: "none"};
        if(this.state.showEmailPopup){
            _style.display = "block";
        }
        return (
            <div className="publisher-send-email-popup " style={_style}>
                <div className="email-error-msg">{this.state.errors}</div>
                <div className="send-via-title">
                    {t('Send via email')}
                </div>
                <div>
                    <input className="send-email-textbox" type="text" ref="emails" name="emails" placeholder={this.props.emailPlaceholder} />
                </div>
                <div className="send-via-title">
                    {t('Subject')}
                </div>
                <div>
                    <input className="send-email-textbox" type="text" ref="subject" name="subject" placeholder={this.props.emailSubjectPlaceholder} />
                </div>
                <div>
                    <div className="gbl-btn align-send-btn" onClick={ e => this.sendEmail(e)}>{t('Send')}</div>
                </div>
            </div>
        )
    }

    renderSlackRow(c, prefixLable = ''){
        return (
            <div className="goal-table-row divInlineBlock metricUpdate">
                <div className="goal-table-col rememberMe selection-option-check" style={{width: "40px"}}>
                    <input id={"slack_" + prefixLable + c.id} className="wsSearchCheckbox slack-ids-ims" data-slack-id={c.id} type="checkbox" name="slack_ids[]"  value={c.id} />
                    <label htmlFor={"slack_" + prefixLable +  c.id}></label>
                </div>
                <div className="goal-table-col">
                    {c.name}
                </div>
            </div>
        )
    }

    renderSlackPopup(){
        let channels = this.state.slackData.channel || [];
        let im = this.state.slackData.im || [];
        let teamName = this.state.slackData.teamName || [];
        let _style = {display: "none"};
        if(this.state.showSlackPopup){
            _style.display = "block";
        }
        return (
            <div className="publisher-slack-publish-popup" style={_style}>
                <div className="email-error-msg">{this.state.errors}</div>
                <div className="goal-table-tmp">
                    <div className="goal-table-row-tmp">
                        <div className="goal-table-col slack-team-title">
                            {t('Slack Team')}: <span id="slack-team-name" style={{fontWeight: 600}}>{teamName}</span>
                        </div>
                        <div className="goal-table-col right" >
                            <input type="button" className="gbl-btn gbl-btn-slim" onClick={ e => this.publishSlack(e)} value="Publish" />
                        </div>
                    </div>
                </div>
                <div id="slack-list" className="goal-table-tmp verticalScroll fixed-height">
                    <div className="goal-table-row-tmp">
                        <div className="goal-table-col" style={{fontWeight: 600}}>{t('CHANNELS')}</div>
                        <div className="goal-table-col">&nbsp;</div>
                    </div>
                    {
                       channels.length ? channels.map(c => this.renderSlackRow(c, 'ch')) : ''
                    }
                    <div className="goal-table-row-tmp">
                        <div className="goal-table-col" style={{fontWeight: 600}}>
                        {t('DIRECT MESSAGES')}
                        </div>
                        <div className="goal-table-col">&nbsp;</div>
                    </div>
                    {
                      im.length ?  im.map(c => this.renderSlackRow(c, 'im')) : ''
                    }
                </div>
            </div> 
        )
    }

    clearCheckBoxes(){
        var checkboxes =  document.querySelectorAll("input[name^='slack_ids[']");
        if(checkboxes){
            for(let check of checkboxes){
                check.checked = false;
            }
        }
    }

    publishSlack(e){
        e.preventDefault();
        let _this = this;
        var slackIds = [];
        var checkedSlackBoxes =  document.querySelectorAll("input[name^='slack_ids[']:checked");
        if(checkedSlackBoxes){
            for(let check of checkedSlackBoxes){
                if(check.value){
                    slackIds.push(check.value);
                }  
            }
        }
        if(!slackIds.length){
            this.setState({errors: 'Please select atleast one channel.'});
        }
        else{
            this.IntegrationServices.goalAlignPublish({appId: 1, slack_ids: slackIds})
                    .then(function(response){
                        if(response.data){
                            infoPopup.call(' &nbsp;&nbsp;&nbsp;Successfully published in Slack.');
                        }
                        _this.setState({errors:'', showEmailPopup: false, showSlackPopup: false});
                    });
        }
        
    }

    render(){
        return (
            <div ref={this.setWrapperRef} className="publisher-comp-wrapper">
                {
                    this.props.showSlack ?
                    <div className="publisher-comp-icon icon icon-slack-24px" onClick={ e => this.clickSlackView(e) } width="15">
                        { this.renderSlackPopup() }
                    </div> : ''
                } 
                <div className="publisher-comp-icon icon icon-outline-print-24px" onClick={ e => this.clickPrintView(e)}></div>
                <div className="publisher-comp-icon icon icon-outline-mail-24px" onClick={ e => this.clickEmailView(e)}>
                    {this.renderEmailPopup()}
                </div>
            </div>
        )
    }
}

PublisherComp.defaultProps = {
    showSlack: false,
    printUrl: '',
    publishSlackUrl: '',
    emailPlaceholder: 'Enter one or more email addresses separated by commas',
    emailSubjectPlaceholder: 'Progress Report',
    emailSendUrl: ''
}

export default withTranslation()(PublisherComp);